import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Refresh my C++ 11 brain and upgrade to 17...`}</p>
    <h1>{`Why?`}</h1>
    <p>{`After learning Rust, I feel ready to absorb some good parts of modern C++.`}</p>
    <h1>{`Book: `}<a parentName="h1" {...{
        "href": "https://changkun.de/modern-cpp/"
      }}>{`Modern C++`}</a>{`(⭐⭐⭐)`}</h1>
    <p>{`I found the book can be compressed to a few bullet points for myself:`}</p>
    <h2>{`Cheatsheet`}</h2>
    <ul>
      <li parentName="ul">{`use nullptr instead of NULL`}</li>
      <li parentName="ul">{`constexpr for e.g. function fibonacci of compile time; also prefer use constexpr instead of const for compile time constants`}</li>
      <li parentName="ul">{`if/switch ( tmp variable ; ...) allow variables like for loop`}</li>
      <li parentName="ul">{`std::intializer_list<int`}{`>`}{` -> { 1, 2, 3} for sizable input`}</li>
      <li parentName="ul">{`tuple and destructor auto `}{`[x, y, z]`}{` = std::make_tuple<int, double, std::string`}{`>`}{`(...); std::get<0`}{`>`}{`(tuple) get 0 element`}</li>
      <li parentName="ul">{`destructor assignment works for many other types, pair, POD struct, array, etc.`}</li>
      <li parentName="ul">{`get auto type: std::is_same<decltype(x), int>::value`}</li>
      <li parentName="ul">{`if constexpr( compile time if branch) {...`}</li>
      <li parentName="ul">{`use 'using' instead of typedef`}</li>
      <li parentName="ul">{`auto can be return value for template and can be parameters for functionals`}</li>
      <li parentName="ul">{`default template type template<typename T = int, typename U = int `}{`>`}</li>
      <li parentName="ul">{`skipped some parts due to sick of any unreadable meta programming ... unless you want to implement refection`}</li>
      <li parentName="ul">{`use enum class:type instead of enum`}</li>
      <li parentName="ul">{`constructor can call other constructor. Yay!`}</li>
      <li parentName="ul">{`inherit constructor with 'using Base::Base';`}</li>
      <li parentName="ul">{`java flavor override and final: virtual foo() override; or virtual foo() final;`}</li>
      <li parentName="ul">{`explicitly constructors: Magic()= default; Magic(const Magic& )=delete; Magic& operator=(const Magic &)=delete;`}</li>
      <li parentName="ul">{`lambda: `}{`[`}{`&`}{`]`}{`(`}{`args`}{`)`}{` -> returnee {...} [] can be empty or values that want to capture in function when contructing lambda`}</li>
      <li parentName="ul">{`use std::function<...`}{`>`}{` instead of pointer`}</li>
      <li parentName="ul">{`bind function: std::bind(foo, std::placeholders::_1, 1,2) new function takes only one arg`}</li>
      <li parentName="ul">{`T&& extends the life of rvalue and can change it. while T&& itself as ref is lvalue.`}</li>
      <li parentName="ul">{`vec.push_back(std::move(str)) here move change the temp rvalue to left value and saved copy contructing`}</li>
      <li parentName="ul">{`prefer std::array to T[] and you can get pointer by std::array.data()`}</li>
      <li parentName="ul">{`std::forward_list single linked list vs std::list double linked list`}</li>
      <li parentName="ul">{`std::shared_ptr get() reset() use_count() std::make_shared<T`}{`>`}{`(0) to create`}</li>
      <li parentName="ul">{`std::regex_match(std::string, std::regex) `}</li>
      <li parentName="ul">{`std::thread(lambda, args) and then join()`}</li>
      <li parentName="ul">{`std::future<T`}{`>`}{` f = std::async(std::launch::async, []{ return t; }); and f.wait();`}</li>
      <li parentName="ul">{`new lock guard std::unique_ptr > std::lock_guard<std::mutex `}{`>`}{` lock(a_mutex);`}</li>
      <li parentName="ul">{`std::atomic<T`}{`>`}{` fetch_add() fetch_sub() and is_lock_free to check if support on platform`}</li>
      <li parentName="ul">{`std::this_thread::sleep_for(std::chrono::milliseconds(900));`}</li>
      <li parentName="ul">{`Raw multiline string R"()";`}</li>
      <li parentName="ul">{`alignof and alignas. Wow, my ancient memory of struct alignment.`}</li>
    </ul>
    <h1>{`My Addition`}</h1>
    <p>{`The book didn't cover every interesting aspect and filesystem is missing (TODO). So here I did some adding for complete:`}</p>
    <ul>
      <li parentName="ul">{`use std::string_view replacing c style string or every c++ const std::string&, and get bonus like start_with(), substr() and better performance etc. view is `}<strong parentName="li">{`read only`}</strong>{` but don't use in case when immutable is required like e.g. key for hashmap.`}</li>
      <li parentName="ul">{`initialize class member inside class like integer and for `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`static`}</code>{` you just need to add `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`inline`}</code></li>
      <li parentName="ul">{`std::optional<T`}{`>`}{` std::nullopt and error handling`}</li>
      <li parentName="ul">{`std::iota(v.begin(), v.end(), start_value) == range_set_container(start_value)`}</li>
      <li parentName="ul">{`std::ref and std::cref return std::reference_wrapper for convenience (e.g. shuffle list using vector referencing to the list element)`}</li>
      <li parentName="ul">{`std::swap and std::iter_swap`}</li>
      <li parentName="ul">{`other good stuff in algorithms e.g. copy, shuffle, sort etc.`}</li>
      <li parentName="ul">{`std::remove_const to remove const and const_cast`}</li>
      <li parentName="ul">{`get type name typeid(variable).name()`}</li>
      <li parentName="ul">{`static_assert(sizeof(CLASS)==16) for compile time`}</li>
    </ul>
    <h2>{`My Practice Notes`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cpp"
    }}><pre parentName="div" {...{
        "className": "language-cpp"
      }}><code parentName="pre" {...{
          "className": "language-cpp"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// Types`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`using`}</span>{` i32`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`using`}</span>{` u32`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`unsigned`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`using`}</span>{` u64`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`unsigned`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`long`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`long`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`using`}</span>{` i64`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`long`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`long`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`using`}</span>{` i8`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`char`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`using`}</span>{` u8`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`unsigned`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`char`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// replace every old array with this...`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`constexpr`}</span>{` std`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`::`}</span>{`array arr `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"hello"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"world"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
cout `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` arr`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`size`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//no more sizeof(T[])/sizeof(T) and basically vector's a few read method`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//same value for every element?`}</span>{`
arr`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`fill`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// or std::to_array(), ancient c style can intial to 0 when ={0} though`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// always prefer string_view to char[]`}</span>{`
string_view v `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` str `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`/*const char* or string*/`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`while`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`i`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{` v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`size`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`isspace`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`i`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`++`}</span>{`i`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`while`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`j`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`i `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`isspace`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`j`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`--`}</span>{`j`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
cout `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`substr`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`i`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` j`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span>{`i`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
string s`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`data`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`size`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//copy back to a new string`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Lambda instead of functor`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sort`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`begin`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`end`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token comment"
          }}>{`/*capture list here*/`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`auto`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`auto`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`->`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`bool`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` x `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// to implement similar algorithm`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`template`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`typename`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`InputIterator`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`typename`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`InputIterator`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`typename`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Compare`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sort`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`InputIterator begin`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` InputIterator end`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` Compare cmp`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`for_each`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`map`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`begin`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` map`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`end`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` std`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`::`}</span>{`pair`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`K`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`V`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`entry`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`push_back`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`entry`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`transform`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`map`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`begin`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` map`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`end`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` destination`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` lambda`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// GetOrDefault`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`map`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`emplace`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`key`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` value`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`first`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`->`}</span>{`first `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`or`}</span>{` second`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// .first is iterator of entry .second is bool`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Heavy String manipulate and different type e.g. string_view`}</span>{`
stringstream `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`char`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` string_view`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<<`}</span>{` string`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`
stringstream `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>>`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`and`}</span>{` stoi

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Random #`}</span>{`
default_random_engine eng`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
uniform_int_distribution`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`dist`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`dist`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`eng`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`->`}</span>{` random number in `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// String and values`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`to_chars`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`first`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` any primitive type`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` 
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`from_chars`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`first`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` out`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` base`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`->`}</span>{`from_chars_result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`*`}</span>{`ptr`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` errc`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`::`}</span>{`out_of_range `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// check if e == errc() `}</span>{`
to_string `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` stoi `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// throws and locale stof stod`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// startwith`}</span>{`
str`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`compare`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` prefix`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`size`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` prefix`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`==`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Tokenize: getline(sstr, output, '.') is old fashion and char delimiter`}</span>{`
sregex_token_iterator `}<span parentName="code" {...{
            "className": "token function"
          }}>{`it`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`str`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`begin`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` str`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`end`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`regex`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`R`}<span parentName="code" {...{
            "className": "token string"
          }}>{`"[.]+"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// powerful`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Compare`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`auto`}</span>{` myCmp `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`auto`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`auto`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`->`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`bool`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` x `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// less as default`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`sort`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`first`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` last`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` myCmp`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
priority_queue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`T`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` vector`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`T`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`decltype`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`myCmp`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`pq`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`myCmp`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// high priority first(max value) with default less comparator`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// compare vector etc.`}</span>{`
vector`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` A`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` B`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
A `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{` B`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//as in lexico order`}</span>{`
tuple`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` C`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` B`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span><span parentName="code" {...{
            "className": "token comment"
          }}>{`// similar to vector`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// String manipulate is painful in c++`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// C++20 string`}</span>{`
string x `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` std`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`::`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`format`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"{:.2f}"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` a`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//float a; goodbye to stringstream`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Override hash for your object`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`auto`}</span>{` my_hash `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{` x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`->`}</span>{`size_t`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    hash`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
unordered_map`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`int`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`decltype`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`my_hash`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` hashmap

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// gcd lcm`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`gcd`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`lcm`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`// 2d array
// change
int DIR`}{`[4][2]`}{` = {
{1, 0},
{-1,0},
{0, 1},
{0,-1}
};
// to (note extra brackets)
array<array<int, 2>, 4> = {{
{1, 0},
{-1,0},
{0, 1},
{0,-1}
}};`}</p>
    {
      /* for myself, not necessary new features
      # sum
      * accumulate(begin, end, 0);
      * lower_bound search >= given val, upper_bound search > given val when given less default comparator
      * max_element or minmax_element return it
      # Pointer Refresher
      * shared_ptr weak_ptr(lock to shared_ptr) is for heap object, stack object can be unique_ptr or reference_wrapper
      ## Containers
      * construction {1, 2, 3, ...}; or {{1, 2}, ...}; note constructor({}) == {{}}; destruction auto [x, y, z]; 
      * value_type basically whatever in container<...\>
      * join: either boost::algorithm::join(container, ",") or do it simply like if(!output.empty()) output+=delim;
      * linkedhashmap use list + map to implement, use prev/next to get list(double linked, single is forward_list)
      * vector<bool> is space efficient, or boost::dynamic_bitset
      * bool all_of(begin, end, []()->bool{}); or none_of
      * parse string with char delimiter... just use stringstream and getline(sstr, output, '.')
      * appending vector using v1.insert(v1.end(), v2.begin(), v2.end()) is efficient, assign is for overwriting
      * auto& t = qu.front(); qu.pop(); this is not right since it's popped
      * https://howardhinnant.github.io/stack_alloc.html short_allocator using stack for small stl is efficient: using tiny_vector = std::vector<T, short_alloc<T, BufSize, alignof(T)\>\>;
      ## String
      * tolower for char, for string use transform(begin, end, tolower)
      * stringstream << ... <<
      * istringstream("...") std::istream_iterator<T\>(istream)
      * ostringstream std::ostream_iterator<T\>(ostream, delim)
      -*/
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      